import generatedGitInfo from "../generatedGitInfo.json";
import { apiEnvDict, getCurrentEnv } from "./Api";

const year = new Date().getFullYear();
const apiEnv = getCurrentEnv();
const apiEnvTitle = apiEnvDict?.find((item) => item.value === apiEnv)?.title;
export const footerText = `Copyright hubs101 © ${year} - ${apiEnvTitle} System - ${generatedGitInfo.gitBranch} Branch`;
